import { render } from "./KnowledgeDetail.vue?vue&type=template&id=4249c529&scoped=true"
import script from "./KnowledgeDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeDetail.vue?vue&type=script&lang=js"

import "./KnowledgeDetail.vue?vue&type=style&index=0&id=4249c529&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4249c529"]])

export default __exports__